import React from 'react';
import { colors } from '@styleseat/brand';

type BasicCutIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const BasicCutIcon = ({
  width = 24,
  height = 24,
  color = colors.blackInBlack,
}: BasicCutIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8065 1.44153L19.4655 2.55847L13.2055 11.8568L15.5552 15.3469C16.0033 15.1732 16.4905 15.078 17 15.078C19.2091 15.078 21 16.8689 21 19.078C21 21.2871 19.2091 23.078 17 23.078C14.7909 23.078 13 21.2871 13 19.078C13 18.1023 13.3494 17.2081 13.9298 16.5139L12 13.6474L10.0702 16.5139C10.6506 17.2081 11 18.1023 11 19.078C11 21.2871 9.20914 23.078 7 23.078C4.79086 23.078 3 21.2871 3 19.078C3 16.8689 4.79086 15.078 7 15.078C7.50946 15.078 7.99667 15.1732 8.44481 15.3469L10.7945 11.8568L4.53448 2.55847L6.19352 1.44153L12 10.0662L17.8065 1.44153ZM9 19.078C9 20.1826 8.10457 21.078 7 21.078C5.89543 21.078 5 20.1826 5 19.078C5 17.9734 5.89543 17.078 7 17.078C8.10457 17.078 9 17.9734 9 19.078ZM19 19.078C19 20.1826 18.1046 21.078 17 21.078C15.8954 21.078 15 20.1826 15 19.078C15 17.9734 15.8954 17.078 17 17.078C18.1046 17.078 19 17.9734 19 19.078Z"
      fill={color}
    />
  </svg>
);
